module.exports = __webpack_public_path__ + "img/bannerimg7.0655a7b1.png";